import React from 'react';
import styles from './page_container.css';

export function PageContainer({ children }: { children: React.ReactNode }) {
  return <div className={styles.pageContainer}>{children}</div>;
}
